export const getFormattedAmount = (value: number, noCurrencySymbol?: boolean, noComma?: boolean, noZeroDecimals?: boolean): string => {
  let formatted = new Intl.NumberFormat(
    'en-PK',
    {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }
  ).format(value);

  if (noCurrencySymbol) {
    formatted = formatted.replace('PKR', '').replace('Rs', '');
  }

  if (noComma) {
    formatted = formatted.replace(',', '');
  }

  if (noZeroDecimals) {
    formatted = formatted.replace('.00', '');
  }

  return formatted.trim();
};
